//NPM Packages
import { React } from "react";
import styled from "styled-components";

const FormBody = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

export default function LamininSent(props) {
  return (
    <FormBody>
      Thank you for submitting your information, your Reference Number (Laminin
      Lead ID) is {props.leadId}. One of our representatives will be in contact
      with you shortly.
    </FormBody>
  );
}
